import Controller from '@ember/controller';
import {
  action,
  computed,
  get,
  getProperties,
  set,
  setProperties,
} from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { task } from 'ember-concurrency';
import moment from 'moment';

export default Controller.extend({
  abilities: service(),
  coachingService: service(),
  store: service(),

  queryParams: ['preserveScrollPosition'],

  preserveScrollPosition: true,
  showNavigationModal: false,
  editingReportCoachNotes: false,
  saveReportCoachNotesError: null,
  editingIndividualCoachNotes: false,
  saveIndividualCoachNotesError: null,
  editingFeedback: false,
  saveFeedbackError: null,

  report: alias('model.record'),

  onLastReport: computed('report.id', function () {
    return (
      get(this, 'model.individualRecord.sortedReports.lastObject.id') ===
      get(this, 'report.id')
    );
  }),

  canAddReport: computed('onLastReport', 'report.completed', function () {
    return (
      this.onLastReport &&
      this.report.completed &&
      this.abilities.hasCoachingAbility('edit_report')
    );
  }),

  canEditGoal: computed('model.individualRecord.id', function () {
    return this.abilities.hasCoachingAbility('edit_goal');
  }),

  monthsToRaiseSupport: computed('model.individualRecord.id', function () {
    let individualRecord = get(this, 'model.individualRecord');
    let { startDate, goalDate } = getProperties(
      individualRecord,
      'startDate',
      'goalDate',
    );
    if (isEmpty(goalDate)) {
      return 0;
    }
    let goalDateString = moment(goalDate).format('YYYYMMDD');
    let date = moment(startDate);
    let months = -1;
    while (date.format('YYYYMMDD') < goalDateString) {
      months += 1;
      date.add(1, 'months');
    }
    // if it's within 15 days after the goal date, then count it as another month
    if (date.subtract(15, 'days').format('YYYYMMDD') < goalDateString) {
      months += 1;
    }
    return months;
  }),

  reset() {
    setProperties(this, {
      editingReportCoachNotes: false,
      saveReportCoachNotesError: null,
      editingIndividualCoachNotes: false,
      saveIndividualCoachNotesError: null,
      editingFeedback: false,
      saveFeedbackError: null,
    });
  },

  expandedSections: {},

  expandAllSections() {
    let expanded = {};
    get(this, 'model.individualRecord.sections').forEach((section) => {
      expanded[get(section, 'l')] = true;
    });
    set(this, 'expandedSections', expanded);
  },

  saveReportCoachNotes: task(function* () {
    if (this.abilities.noCoachingAbility('edit_coach_note')) {
      return;
    }
    set(this, 'saveReportCoachNotesError', null);
    let report = get(this, 'model.record');
    let coachNotesText = this.reportCoachNotesText;
    set(report, 'coachNotes', coachNotesText);
    try {
      yield report.save();
      setProperties(this, {
        editingReportCoachNotes: false,
        coachNotesText: '',
      });
    } catch (error) {
      set(this, 'saveReportCoachNotesError', error);
    }
  }),

  saveIndividualCoachNotes: task(function* () {
    if (this.abilities.noCoachingAbility('edit_coach_note')) {
      return;
    }
    set(this, 'saveIndividualCoachNotesError', null);
    let individual = get(this, 'model.individualRecord');
    let coachNotesText = this.individualCoachNotesText;
    set(individual, 'coachNotes', coachNotesText);
    try {
      yield individual.save();
      setProperties(this, {
        editingIndividualCoachNotes: false,
        individaulCoachNotesText: '',
      });
    } catch (error) {
      set(this, 'saveIndividualCoachNotesError', error);
    }
  }),

  saveFeedback: task(function* () {
    if (this.abilities.noCoachingAbility('edit_coach_note')) {
      return;
    }
    set(this, 'saveFeedbackError', null);
    let report = get(this, 'model.record');
    let feedbackText = this.feedbackText;
    set(report, 'feedback', feedbackText);
    try {
      yield report.save();
      setProperties(this, {
        editingFeedback: false,
        feedbackText: '',
      });
    } catch (error) {
      set(this, 'saveFeedbackError', error);
    }
  }),

  toggleExpandedSection: action(function (sectionLabel) {
    let property = `expandedSections.${sectionLabel}`;
    this.toggleProperty(property);
  }),

  handleShowCoachingPaginationModalChange: action(function (show) {
    set(this, 'showNavigationModal', show);
  }),

  editReportCoachNotes: action(function () {
    setProperties(this, {
      editingReportCoachNotes: true,
      reportCoachNotesText: get(this, 'model.record.coachNotes'),
    });
  }),

  cancelEditReportCoachNotes: action(function () {
    setProperties(this, {
      editingReportCoachNotes: false,
      coachNotesText: '',
    });
  }),

  editIndividualCoachNotes: action(function () {
    setProperties(this, {
      editingIndividualCoachNotes: true,
      individualCoachNotesText: get(this, 'model.individualRecord.coachNotes'),
    });
  }),

  cancelEditIndividualCoachNotes: action(function () {
    setProperties(this, {
      editingIndividualCoachNotes: false,
      individualCoachNotesText: '',
    });
  }),

  editFeedback: action(function () {
    setProperties(this, {
      editingFeedback: true,
      feedbackText: get(this, 'model.record.feedback'),
    });
  }),

  cancelEditFeedback: action(function () {
    setProperties(this, {
      editingFeedback: false,
      feedbackText: '',
    });
  }),
});
